import { Injectable } from '@angular/core';
import { BaseHttpService } from '@core/data/http/base-http.service';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TimeoffDataService extends BaseHttpService {

    private urls = {
        timeoffTypes: '/timeoffs/types'
    };


    fetchTimeoffTypes(queryParams?: any): Observable<any> {
        let url: string = environment.api.endpoint + this.urls.timeoffTypes;

        if (queryParams) {
            url = `${url}${this.toQueryParams(queryParams)}`;
        }

        return this.get(url, undefined, true);
    }
}

